import React, {
  // useEffect,
  useState,
} from "react"
import UpTriangleIcon from "../../icons/UpTriangleGrey.svg"
import DownTriangleIcon from "../../icons/DownTriangleGrey.svg"
import Wait from "../../icons/wait.svg"
import { Dialog } from "@mui/material"
import {
  addRuletoPipeline,
  setActiveQualityTypeReport,
  setActiveReportModal,
  // setRulePipelineStatusLoading,
  // pollRulePipelineStatusAsync,
} from "./DataQualitySlice"
// import DownloadDropdown from "./DownloadDropdown"
import { useAppDispatch, useAppSelector } from "../../util/hooks"
import { IRulePipelineStatus } from "../../util/interface"
// import { API_STATUS } from "../../util/StaticData"
import { sampleOverViewData } from "./staticData"

export interface TableRowData {
  id: string | number
  qualityType: string
  qualityRulesEnabled: string
  pepelineImplementationStatus: string
  ruleRunProgress: number
  new: boolean
  addedToPipeline: boolean
}

const NewTag = () => (
  <div className="flex h-[35px] w-[35px] rounded-full border border-customRed-50 rotate-[-30deg]  aspect-square">
    <p className="text-customRed-50 text-[8px] font-bold self-center mx-auto leading-[10px]">
      Newly Added
    </p>
  </div>
)

const TableHeader: React.FC = () => {
  const headers = [
    "Quality Type",
    "Quality Rules Enabled",
    "Status of Run Progress",
    "Review & Run",
    "Added to Pipeline",
  ]

  return (
    <thead>
      <tr>
        {headers.map((header, index) => (
          <th
            key={index}
            className="border-t border-bgGrey-450 px-4 py-2 text-[11px] text-textGrey-50 text-left"
          >
            <div
              className={`flex gap-2 ${
                index === 0 || index === 1 ? "justify-start" : "justify-center"
              }`}
            >
              {header}
              <div className="flex flex-col">
                <img className="h-2" src={UpTriangleIcon} alt="up" />
                <img className="h-2" src={DownTriangleIcon} alt="down" />
              </div>
            </div>
          </th>
        ))}
      </tr>
    </thead>
  )
}

interface TableRowProps {
  item: IRulePipelineStatus
  index: number
}

const RawDataQualityTableRow: React.FC<TableRowProps> = ({ index, item }) => {
  const dispatch = useAppDispatch()
  const rulesAddedtoPipeline = useAppSelector(
    (state) => state.dataQuality.rulesAddedtoPipeline,
  )

  const isRuleAddedtoPipeline = () => {
    return rulesAddedtoPipeline.some(
      (rule) => rule.RULE_TITLE === item.RULE_TITLE,
    )
  }

  const handleOpenDialog = (id: string | number) => {
    dispatch(setActiveReportModal(true))
    dispatch(setActiveQualityTypeReport(id))
  }

  return (
    <tr className="text-xs border-t border-bgGrey-450">
      <td className="px-4 py-6 font-medium">{item.TABLE}</td>
      <td className="px-4 text-center font-semibold">
        <div className="flex grow items-center gap-4">
          <p className="text-left">{item.RULE_TITLE}</p>
          {(index === 0 || index === 3) && <NewTag />}
        </div>
      </td>
      <td className="text-center font-semibold">
        <div className="flex items-center justify-center">
          <p
            className={`flex justify-center items-center h-5 px-2 ${
              item.SQL_EXECUTION_STATUS === "COMPLETED" ||
              item.SQL_EXECUTION_STATUS === "PASSED"
                ? "text-textGreen-50 bg-bgGreen-50"
                : item.SQL_EXECUTION_STATUS === "FAILED"
                ? "text-primaryRed bg-bgRed-50"
                : "text-textYellow-50 bg-bgYellow-50"
            }`}
          >
            {item.SQL_EXECUTION_STATUS === "PASSED"
              ? "COMPLETED"
              : item.SQL_EXECUTION_STATUS === "PENDING"
              ? "IN PROGRESS"
              : item.SQL_EXECUTION_STATUS === "FAILED"
              ? "FAILED"
              : item.SQL_EXECUTION_STATUS}
          </p>
        </div>
      </td>
      <td className="text-center">
        <button
          onClick={() => handleOpenDialog(item.RULE_TITLE)}
          className={`font-semibold px-7 py-1 rounded-md text-xs ${
            isRuleAddedtoPipeline()
              ? "cursor-pointer border border-[#5C5C5C] text-[#5C5C5C]"
              : item.SQL_EXECUTION_STATUS === "COMPLETED" ||
                item.SQL_EXECUTION_STATUS === "PASSED"
              ? "bg-dpTheme-main cursor-pointer active:bg-[var(--primary-dp-dark-90)] active:shadow-inner focus:outline-none hover:shadow-md text-white"
              : "bg-dpTheme-main/50 text-white"
          }`}
          disabled={
            item.SQL_EXECUTION_STATUS !== "COMPLETED" &&
            item.SQL_EXECUTION_STATUS !== "PASSED"
          }
        >
          Review
        </button>
      </td>
      <td className="px-4 font-medium">
        <div className="flex items-center justify-center">
          <div
            className={`w-[100px] flex items-center justify-center ${
              isRuleAddedtoPipeline()
                ? "border border-textGreen-50 bg-textGreen-50 text-white"
                : "border-b border-[#5C5C5C]"
            }`}
          >
            <p className="flex justify-center items-center h-5 px-2">
              {isRuleAddedtoPipeline() ? "Yes" : "No"}
            </p>
          </div>
        </div>
      </td>
    </tr>
  )
}

interface TableComponentProps {
  data: IRulePipelineStatus[]
}

const RawDataTable: React.FC<TableComponentProps> = ({ data }) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [rowsPerPage, setRowsPerPage] = useState(5)

  const indexOfLastRow = currentPage * rowsPerPage
  const indexOfFirstRow = indexOfLastRow - rowsPerPage
  const currentRows = data.slice(indexOfFirstRow, indexOfLastRow)
  const totalPages = Math.ceil(data.length / rowsPerPage)

  const handleNextPage = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1)
    }
  }

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1)
    }
  }

  const handleRowsPerPageChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setRowsPerPage(Number(event.target.value))
    setCurrentPage(1)
  }

  return (
    <div className="flex flex-col overflow-x-auto grow">
      <table className="min-w-full bg-transparent">
        <TableHeader />
        <tbody>
          {currentRows.map((item, index) => (
            <RawDataQualityTableRow key={index} index={index} item={item} />
          ))}
        </tbody>
      </table>

      {/* Pagination Controls */}
      <div className="flex justify-end items-center py-3 px-10 gap-10">
        <div className="flex items-center gap-2">
          <span className="text-[10px]">Rows per page:</span>
          <select
            value={rowsPerPage}
            onChange={handleRowsPerPageChange}
            className="border rounded w-11 outline-none text-xs"
          >
            {[5, 10, 15, 20].map((value) => (
              <option key={value} value={value}>
                {value}
              </option>
            ))}
          </select>
        </div>

        <div className="flex items-center gap-7 text-[14px]">
          <button
            onClick={handlePrevPage}
            disabled={currentPage === 1}
            className="flex justify-center items-center disabled:opacity-50"
          >
            {"<"}
          </button>
          <p className="font-semibold">
            {currentPage}/{totalPages}
          </p>
          <button
            onClick={handleNextPage}
            disabled={currentPage === totalPages}
            className="flex justify-center items-center disabled:opacity-50"
          >
            {">"}
          </button>
        </div>
      </div>
    </div>
  )
}

const OverView: React.FC = () => {
  const dispatch = useAppDispatch()
  const openDialog = useAppSelector(
    (state) => state.dataQuality.activeReportModal.status,
  )
  // const overViewData = useAppSelector(
  //   (state) => state.dataQuality.rulePipelineStatus,
  // )
  const overViewData = sampleOverViewData
  // const runId = useAppSelector((state) => state.dataQuality.runId)
  // const selectedDataSet = useAppSelector(
  //   (state) => state.dataQuality.selectedDataSet,
  // )
  // const refresh = useAppSelector((state) => state.dataQuality.refreshHit)
  // const activeRuleModalTitle = useAppSelector(
  //   (state) => state.dataQuality.activeReportModal.qualityTypeId,
  // )
  // const pipelineStatusRules = useAppSelector(
  //   (state) => state.dataQuality.rulePipelineStatus,
  // )
  // const activeRuleModalData = pipelineStatusRules.filter(
  //   (item) => item.RULE_TITLE === activeRuleModalTitle,
  // )

  // const DELAY_MS = 20000
  // useEffect(() => {
  //   if (runId) {
  //     dispatch(setRulePipelineStatusLoading(API_STATUS.LOADING))
  //     setTimeout(() => {
  //       dispatch(pollRulePipelineStatusAsync(runId))
  //     }, DELAY_MS)
  //   }
  // }, [runId, dispatch, refresh])

  // const ColData = [
  //   {
  //     left: "Dataset Applied",
  //     right: selectedDataSet?.length
  //       ? selectedDataSet[0].toUpperCase() +
  //         selectedDataSet.slice(1).toLowerCase()
  //       : "-",
  //   },
  //   {
  //     left: "Column Names",
  //     right: activeRuleModalData[0]?.RULE_COLUMNS_TO_APPLY || "-",
  //   },
  //   {
  //     left: "Total Rows Scanned",
  //     right: activeRuleModalData[0]?.RESULT || "-",
  //   },
  //   { left: "Issues Identified", right: activeRuleModalData[0]?.RESULT || "-" },
  //   { left: "Previous Threshold", right: "-" },
  //   { left: "Current Threshold", right: "-" },
  //   { left: "QC Passed with Threshold", right: "-" },
  // ]
  const ColData = [
    {
      left: "Dataset Applied",
      right: "Sales",
    },
    {
      left: "Column Names",
      right: "Product Desc",
    },
    {
      left: "Total Rows Scanned",
      right: "15,000",
    },
    { left: "Issues Identified", right: "23" },
    { left: "Previous Threshold", right: "NA" },
    { left: "Current Threshold", right: ">=95%" },
    { left: "QC Passed with Threshold", right: "Yes/No" },
  ]

  // const handleDownloadClick = () => {
  //   console.log("Download clicked")
  // }

  const handleCloseDialog = () => {
    dispatch(setActiveReportModal(false))
  }

  const handleImplementDataPipeline = () => {
    dispatch(addRuletoPipeline())
  }

  return (
    <div className="flex flex-col w-full relative">
      {/* content */}
      <div className="flex flex-col my-4 grow bg-white rounded-lg px-6">
        <div className="flex justify-start items-center py-3 gap-2">
          <img className="h-[18px]" src={Wait} alt="wait" />
          <p className="font-semibold">Summary Overview</p>
        </div>

        <div className="flx grow">
          <RawDataTable data={overViewData} />
        </div>
      </div>

      <div className="absolute top-[-40px] right-0">
        {/* <DownloadDropdown
          options={["Schema", "Rows Processed", "Unique & Not Null"]}
          onOptionClick={handleDownloadClick}
        /> */}
      </div>

      <Dialog open={openDialog} onClose={handleCloseDialog} maxWidth="lg">
        <div className="flex flex-col w-[448px] h-[400px] p-7 gap-2">
          <div className="grid grid-cols-2 grid-rows-7 h-[272px] w-full border-b-[4px] border-t-[4px] border-r-[1px] border-l-[1px] border-[#E6ECFO]">
            {ColData.map((item, index) => (
              <React.Fragment key={index}>
                <div className="bg-[#FAFAFA] flex items-center justify-start pl-5 text-xs font-bold border-r border-[#E6ECFO] w-full h-full">
                  {item.left}
                </div>
                <div className="flex items-center justify-start pl-5 text-xs w-full h-full">
                  {item.left === "Issues Identified" ||
                  item.left === "Total Rows Scanned" ? (
                    <div className="w-full">
                      {typeof item.right !== "string" ? (
                        // <IssueTable
                        //   tableData={{
                        //     Column: item.right.Column,
                        //     ColumnData:
                        //       item.left === "Issues Identified"
                        //         ? item.right.Violation_Count
                        //         : item.right.Total_Count,
                        //   }}
                        // />
                        <IssueTable
                          tableData={{
                            Column: item.right,
                            ColumnData:
                              item.left === "Issues Identified"
                                ? item.right
                                : item.right,
                          }}
                        />
                      ) : (
                        <p className="text-xs">{item.right}</p>
                      )}
                    </div>
                  ) : (
                    item.right
                  )}
                </div>
              </React.Fragment>
            ))}
          </div>

          <div className="flex flex-col justify-between grow">
            <p className="text-xs">
              Remark: This is a space for the remarks. You can add it here.
            </p>

            <button
              onClick={handleImplementDataPipeline}
              className="w-fit font-semibold px-5 py-1 rounded-md text-xs bg-[var(--primary-dp-color)] cursor-pointer active:bg-[var(--primary-dp-dark-90)] active:shadow-inner focus:outline-none hover:shadow-md text-white"
            >
              Implement in Data Pipeline
            </button>
          </div>
        </div>
      </Dialog>
    </div>
  )
}

export default OverView

interface ITableData {
  tableData: {
    Column: string[]
    ColumnData: number[]
  }
}

const IssueTable: React.FC<ITableData> = ({ tableData }) => {
  return (
    <div className="overflow-x-auto custom-scrollbar mr-[10px] pb-[3px]">
      <table
        className="w-full border border-black"
        style={{
          whiteSpace: "nowrap",
          borderCollapse: "collapse",
        }}
      >
        <thead>
          <tr>
            {tableData.Column.map((col, index) => (
              <th className="text-xs text-left border border-black" key={index}>
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          <tr>
            {tableData.ColumnData.map((data, index) => (
              <td className="text-xs text-left border border-black" key={index}>
                {data}
              </td>
            ))}
          </tr>
        </tbody>
      </table>
    </div>
  )
}
